import { DataItemFormatter, Tooltip } from '@creditsights/styleguide-web';
import classNames from 'classnames/bind';
import React, { ReactElement, useRef } from 'react';
import { Link } from 'react-router-dom';
import { SavedSearch } from '@creditsights/api-ui-web';
import { ROUTES } from '../../../../../Base.constants';
import { NoDataDash } from '../../../../../components/formatters';
import styles from './SearchesTabCellTextRenderer.module.scss';

interface SearchesTabCellTextRendererProps {
  defaultValue?: string;
  indicateEmptyValue?: boolean;
  link?: (item: SavedSearch) => string;
}

const cx = classNames.bind(styles);

const SearchesTabCellTextRenderer: DataItemFormatter<string, ReactElement, SearchesTabCellTextRendererProps> = ({
  value: displayName,
  props,
  item,
}) => {
  const textWrapperRef = useRef<HTMLDivElement>(null);
  const link = props?.link?.(item);
  const isOverflowing =
    textWrapperRef.current && textWrapperRef.current.scrollWidth > textWrapperRef.current.offsetWidth;

  return (
    <Tooltip content={displayName} disabled={!displayName || !isOverflowing}>
      <div className={cx('body')} ref={textWrapperRef}>
        {link ? (
          <Link
            to={{ pathname: ROUTES.search, search: link }}
            className={cx('link')}
            data-testid="searches-tab-cell-renderer"
          >
            {displayName}
          </Link>
        ) : (
          displayName ||
          (props?.indicateEmptyValue && <NoDataDash />) ||
          (item.pageName ? item.pageName : props?.defaultValue)
        )}
      </div>
    </Tooltip>
  );
};

export default SearchesTabCellTextRenderer;
